export default __webpack_public_path__ + "static/media/Resources.e3396eff.svg";